import { render, staticRenderFns } from "./refresh-clock.vue?vue&type=template&id=5c7c569c&"
import script from "./refresh-clock.vue?vue&type=script&lang=js&"
export * from "./refresh-clock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c7c569c')) {
      api.createRecord('5c7c569c', component.options)
    } else {
      api.reload('5c7c569c', component.options)
    }
    module.hot.accept("./refresh-clock.vue?vue&type=template&id=5c7c569c&", function () {
      api.rerender('5c7c569c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/refresh-clock.vue"
export default component.exports